import { Button, Dialog, Text, VSpacer } from '@/components/DesignSystem';
import { ApiRetailer } from '@api/interfaces';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface HowToEarnPointsModalProps {
  brandColor: string,
  grantBoth: boolean,
  onClose: () => void,
  retailer: ApiRetailer,
}

export const HowToEarnPointsModal = ({
  brandColor,
  grantBoth,
  onClose,
  retailer,
}: HowToEarnPointsModalProps) => {
  const { t } = useTranslation();
  
  return (
  <Dialog
    cancelButton={(props) => (
      <Button
        onClick={onClose}
        sx={{ color: brandColor }}
        variant="text"
        {...props}
      >
        {t($ => $.common.actions.close)}
      </Button>
    )}
    onClose={onClose}
    open
    showCloseButton={false}
    testID="how-to-earn-points-modal"
    title={t($ => $.customerDashboard.howToEarnPoints.title)}
  >
    <Text category="body-medium" sx={{ color: '#525252' }}>
      {t($ => $.customerDashboard.howToEarnPoints.eligiblePurchases)}
    </Text>
    <VSpacer size="5" />
    <Text category="body-medium" sx={{ color: '#525252' }}>
      {grantBoth
        ? t(
          $ => $.customerDashboard.howToEarnPoints.manufacturerPromo,
          { retailerName: retailer.name },
        )
        : t(
          $ => $.customerDashboard.howToEarnPoints.promoRunning,
          { retailerName: retailer.name },
        )
      }
    </Text>
  </Dialog>
  );
};
